/**
 * The signed-in user's role, read from `localStorage` **when called**, not once at import.
 *
 * Reading it at module scope captures whatever was there when the module was evaluated, and
 * never sees it change. `Router.tsx` did that until #155 and it produced a URL that matched
 * nothing: a module evaluated before login held `undefined` while `App.tsx`, which reads per
 * render, disagreed.
 *
 * Returns `unknown` on purpose. `USER_DATA` is written by the storage interactor but read here
 * as raw JSON, so the caller compares it against `UserType` rather than trusting it to be one.
 */
export const storedUserRole = (): unknown => {
  try {
    return (JSON.parse(localStorage.getItem('USER_DATA') || '{}') as { role?: unknown }).role;
  } catch {
    // A corrupted USER_DATA must not take a whole page down with it.
    return undefined;
  }
};
